import { service } from '@ember/service';
import Component from '@glimmer/component';
import type { DetailedChangeset } from 'ember-changeset/types';
import type AgreementModel from 'garaje/models/agreement';
import type StateService from 'garaje/services/state';
import { buildChangeset, FakeChangeset } from 'garaje/utils/legal-document';

interface FlowsSectionsLegalDocumentsNewComponentSignature {
  Args: {
    agreement: AgreementModel;
  };
}

export default class FlowsSectionsLegalDocumentsNewComponent extends Component<FlowsSectionsLegalDocumentsNewComponentSignature> {
  @service declare state: StateService;

  get vrSubscription(): StateService['vrSubscription'] {
    return this.state.vrSubscription;
  }

  get bccChangeset(): DetailedChangeset<AgreementModel> {
    return buildChangeset(this.args.agreement);
  }

  get ndaChangeset(): DetailedChangeset<AgreementModel> {
    return buildChangeset(this.args.agreement);
  }

  get isSaved(): boolean {
    return !this.args.agreement.isNew && !this.args.agreement.hasDirtyAttributes;
  }

  get changesets(): DetailedChangeset<AgreementModel>[] {
    return [this.bccChangeset, this.ndaChangeset];
  }

  get changeset(): FakeChangeset {
    const changesets = this.changesets ?? [];
    return new FakeChangeset(changesets);
  }
}
